package one.healthium.payments.di

import org.koin.dsl.module

val paymentsModule = module {
    includes(paymentsPlatformModule())
}